export type useNavigationReturn = {
  consultationId: number | undefined;
  isHomePage: boolean;
  isSearchPage: boolean;
  isReportsPage: boolean;
  isReportPage: boolean;
  isSummaryPage: boolean;
  isCaseDetailsPage: boolean;
  isResponsePage: boolean;
  isArchivedResponsePage: boolean;
  isConsultationPage: boolean;
  isBreadcrumbPage: boolean;
  isManageTeamPage: boolean;
  isMonitorPage: boolean;
  isCreateOrganisationPage: boolean;
  isManageOrganisationPage: boolean;
  isLoginPage: boolean;
};

export const useNavigation = (path: string): useNavigationReturn => {
  const homePageRegEx = /^\/$/gi;
  const reportsPageRegEx = /^\/reports$/gi;
  const reportPageRegEx = /^\/report\/[a-z]*$/gi;
  const searchPageRegEx = /^\/search?$/gi;
  const summaryPageRegEx = /^\/consultation\/(\d*)(\/)*$/gi;
  const detailsPageRegEx = /^\/consultation\/(\d*)\/details$/gi;
  const detailsResponsePageRegEx =
    /^\/consultation\/(\d+)(\/)*((response|details)((\/)*(\d*)))*$/gi;
  const responsePageRegEx = /^\/consultation\/(\d*)\/response$/gi;
  const archivedResponsePageRegEx = /^\/consultation\/(\d*)\/response\/(\d*)$/gi;
  const manageTeamPageRegEx = /^\/manageteam$/gi;
  const monitorPageRegEx = /^\/monitor$/gi;
  const createOrganisationPageRegex = /^\/create_organisation$/gi;
  const organisationPageRegex = /^\/organisations\/(\d*)(\/teams|\/users)*$/gi;
  const loginPageRegex = /^\/login/gi;

  const getConsultationId = (): number | undefined => {
    const matches = Array.from(path.matchAll(detailsResponsePageRegEx), (m) => m[1]);
    return matches.length === 1 ? +matches[0] : undefined;
  };

  const consultationId = getConsultationId();
  const isHomePage = !!path.match(homePageRegEx);
  const isSearchPage = !!path.match(searchPageRegEx);
  const isReportsPage = !!path.match(reportsPageRegEx);
  const isReportPage = !!path.match(reportPageRegEx);
  const isSummaryPage = !!path.match(summaryPageRegEx);
  const isCaseDetailsPage = !!path.match(detailsPageRegEx);
  const isResponsePage = !!path.match(responsePageRegEx);
  const isArchivedResponsePage = !!path.match(archivedResponsePageRegEx);
  const isManageTeamPage = !!path.match(manageTeamPageRegEx);
  const isMonitorPage = !!path.match(monitorPageRegEx);
  const isCreateOrganisationPage = !!path.match(createOrganisationPageRegex);
  const isManageOrganisationPage = !!path.match(organisationPageRegex);
  const isLoginPage = !!path.match(loginPageRegex);
  const isConsultationPage =
    isSearchPage ||
    isSummaryPage ||
    isCaseDetailsPage ||
    isResponsePage ||
    isArchivedResponsePage;
  const isBreadcrumbPage =
    isSummaryPage ||
    isReportsPage ||
    isCaseDetailsPage ||
    isResponsePage ||
    isArchivedResponsePage ||
    isReportPage ||
    isManageTeamPage ||
    isCreateOrganisationPage ||
    isManageOrganisationPage;

  return {
    consultationId,
    isHomePage,
    isSearchPage,
    isReportsPage,
    isReportPage,
    isSummaryPage,
    isCaseDetailsPage,
    isResponsePage,
    isArchivedResponsePage,
    isConsultationPage,
    isBreadcrumbPage,
    isManageTeamPage,
    isMonitorPage,
    isCreateOrganisationPage,
    isManageOrganisationPage,
    isLoginPage,
  };
};
